import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { ColorPickerGridCellBase } from '/druid/ColorPickerGridCell.base';
import {
  IColorPickerGridCellProps,
  IColorPickerGridCellStyleProps,
  IColorPickerGridCellStyles,
} from '/druid/ColorPickerGridCell.types';
import { getStyles } from '/druid/ColorPickerGridCell.styles';

export const ColorPickerGridCell: React.FunctionComponent<IColorPickerGridCellProps> = styled<
  IColorPickerGridCellProps,
  IColorPickerGridCellStyleProps,
  IColorPickerGridCellStyles
>(ColorPickerGridCellBase, getStyles, undefined, { scope: 'ColorPickerGridCell' }, true);
